






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import RecursiveCollapse from '@/components/RecursiveCollapse.vue';
import QuicktypeModel from '@/components/QuicktypeModel.vue';
import PreviewModal from '@/components/PreviewModal.vue';
import { BaseResponseDTO, BaseDTO } from '@/types';
import { generateFakerValues } from '@/services/faker';

@Component({
  components: {
    RecursiveCollapse,
    QuicktypeModel,
    PreviewModal
  }
})
export default class Entry extends Vue {
    @Prop({ type: String, required: true }) readonly type!: string;
    @Prop({ type: String, required: true }) readonly id!: string;

    loading = '';
    dataContent!: BaseResponseDTO;
    previewData: any = null;
    showPreviewDialog = false;
    $lodash: any;

    get isEndpoint (): boolean {
      return this.$route.params.type === 'endpoints';
    }

    get entry (): BaseDTO {
      return this.$store.state[this.type] ? this.$store.state[this.type][this.id] : null;
    }

    get currentModel (): BaseDTO {
      return this.$store.getters.getCurrentModel;
    }

    @Watch('entry', { deep: true, immediate: true })
    onDataChange (): void {
      this.setModel();
    }

    setModel () {
      this.$store.dispatch('setModel', this.entry);
    };

    async save (loadingState: string) {
      this.loading = loadingState;
      try {
        await this.$store.dispatch('saveData', {
          type: this.type,
          id: this.id
        }).then(() => {
          if (loadingState === 'save') {
            this.$notify({
              title: 'Success',
              text: 'Your model changes was saved!',
              type: 'success'
            });
          }
        });
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        this.$notify({
          title: 'Warning',
          text: 'An error happened. Please check the console',
          type: 'warning'
        });
      } finally {
        this.loading = '';
      }
    };

    async saveAndGenerate (loadingState: string) {
      this.loading = loadingState;

      try {
        await this.save(loadingState);
        await this.$store.dispatch('saveAndGenerate', {
          type: 'db',
          id: this.id
        }).then(() => {
          this.$notify({
            title: 'Success',
            text: 'Your endpoint has been generated!',
            type: 'success'
          });
        });
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        this.$notify({
          title: 'Warning',
          text: 'An error happened. Please check the console',
          type: 'warning'
        });
      } finally {
        this.loading = '';
      }
    };

    async preview (loadingState: string) {
      this.loading = loadingState;

      // Fix issue with loading state not being set
      setTimeout(async () => {
        let clonedObject = this.$lodash.cloneDeep(this.currentModel);
        clonedObject = await generateFakerValues(clonedObject, clonedObject.timesToRepeat);
        this.previewData = JSON.stringify(clonedObject, null, 2);
        this.loading = '';
        this.showPreviewDialog = true;
      }, 0);
    }

    closePreview () {
      this.showPreviewDialog = false;
    }
}
